import Env from "../base/env.js";
import Channels from "../base/channels.js";
import Launcher from "../view/launcher";
import UISwitcher from "../ui/UISwitcher";
import Announcement from "../components/AnnouncementBar.js";
import StockAlert from "../components/StockAlert";
import { makeExternalLinks } from "../utils/ShopifyHelpers.js";
import {
  EmitCartOpen,
  EmitCartClose,
  EmitMiniFragrancesOpen,
  EmitMiniFragrancesClose,
  EmitMiniFragrances50mlOpen,
  EmitMiniFragrances50mlClose,
} from "../components/CartEvents.js";
import gsap from "gsap";
// import SmoothieLenis from "../fx/SmoothieLenis";
import axios from "axios";

class UI {
  constructor() {
    if (typeof history.scrollRestoration != "undefined") {
      history.scrollRestoration = "manual";
    }
    this.launcher = new Launcher();
    this.detectAppHeight();
    this.resetEnv();
    this.uiSwitch = new UISwitcher();
    this.announcement = new Announcement();
    this.stockAlert = new StockAlert();
    //? Carts Events
    EmitCartOpen();
    EmitCartClose();
    EmitMiniFragrancesOpen();
    EmitMiniFragrancesClose();
    EmitMiniFragrances50mlOpen();
    EmitMiniFragrances50mlClose();
    makeExternalLinks();

    setTimeout(() => {
      // Channels.emit("cart::open");
      // Channels.emit("mainnav::opened");
    }, 500);

    // Smooth
    gsap.delayedCall(0.1, () => {
      // this.smoothie = new SmoothieLenis();
      // this.smoothie.setup();
      // this.smoothie.events();
    });

    // gsap.delayedCall(1, () => {
    //   axios.get("/search/suggest.json?q=boqu").then((data) => {
    //     console.log(data);
    //   });
    // });
    // Env.$html.classList.add("stock-alert-opened");
  }

  appHeight() {
    const doc = document.documentElement;
    doc.style.setProperty("--app-height", `${window.innerHeight}px`);
    doc.style.setProperty(
      "--app-availheight",
      `${window.screen.availHeight}px`
    );
  }

  detectAppHeight() {
    this.appHeight();
    Channels.on("window::smartresize", this.appHeight);
  }

  resetEnv() {
    Channels.on("statechange::before", function () {
      Env.$html.classList.remove("mainnav--isOpened");
    });
    Channels.on("statechange::ready", (current, old, container) => {
      Env.isVisiting = true;

      // Env.$html.classList.remove('skin--isWhite')
      // Env.$html.classList.remove('skin--isDark')
      // Env.$mainNav.classList.remove('is--active');
      Env.$html.classList.remove("force-menu-revealing");
    });
    Channels.on("statechange::finalize", () => {
      Channels.emit("mainnav::closed");
      makeExternalLinks();
    });
  }
}

export default UI;
